import ajaxRequest from './ajax'
import qs from "qs"

//公司列表
export const get_all_company = () => {
    return ajaxRequest.get('company/get_all_company');
}

//新增 更新公司
export const insert_company = params => {
    return ajaxRequest.post("company/insert_company?", params);
}

//新增 更新公司
export const update_company = params => {
    return ajaxRequest.post("company/update_company?", params);
}

//新增公司
export const add_company = params => {
    return ajaxRequest.post("company/add_company", params);
}

//删除公司
export const delete_company = params => {
    return ajaxRequest.post("company/delete_company", params);
}


// WEBPACK FOOTER //
// ./src/api/company.js